@if (kind === 'admin') {
  <div
    [class.checked]="adminCheckbox.checked"
    (click)="toggleAssignment.emit($any(admin))"
    class="admin"
    padding-tb-medium
    padding-lr
  >
    <div layout-horizontal layout-align-items-center>
      <rt-checkbox
        #adminCheckbox
        [value]="$any(admin.id)"
        [checked]="!!checked"
        [formControl]="form!"
        (click)="checkboxClick.emit()"
        margin-right-small-x
      >
      </rt-checkbox>
      <rt-avatar
        [type]="admin.hasAvatar ? 'image' : 'initials'"
        [initials]="admin.initials"
        [size]="'base'"
        [shape]="'oval'"
        [imageSrc]="admin.photoThumbUrl"
        margin-right-medium
        context="admin"
      ></rt-avatar>
      <div layout-vertical>
        <rt-heading>
          <rt-truncate>
            {{ admin.firstName }} {{ admin.lastName }}
            @if (currentAdmin && admin.id === currentAdmin.id) {
              ({{ 'app.common.me' | translate }})
            }
          </rt-truncate>
        </rt-heading>
        <div class="subheading" layout-horizontal>
          <rt-truncate>
            {{ admin.roleName }}
          </rt-truncate>
          @if (roleAssignmentsGroup![admin.roleId]) {
            <rt-divider variant="dot"></rt-divider>
            <span>{{ 'app.visibility.can_view' | translate }}</span>
          }
        </div>
      </div>
    </div>
  </div>
  @if (hasDivider) {
    <rt-divider></rt-divider>
  }
}

@if (kind === 'role' && roleWithAdmins) {
  <div [class.checked]="roleCheckbox.checked" class="role-container">
    <div
      (click)="toggleAssignment.emit(roleWithAdmins)"
      [class.has-padding]="hasPadding"
      [class.has-checkbox-offset]="hasCheckboxOffset"
      class="box role-box"
    >
      <div class="content">
        <rt-checkbox
          #roleCheckbox
          [value]="$any(roleWithAdmins.id)"
          [checked]="!!checked"
          [formControl]="form!"
          (click)="checkboxClick.emit()"
          margin-right-small-x
        >
        </rt-checkbox>
        <div class="member" margin-right-auto>
          <div class="role-avatar">
            <rt-avatar
              [type]="'initials'"
              [size]="'base'"
              [shape]="'oval'"
              [fullName]="roleWithAdmins.name"
              [context]="'admin'"
            ></rt-avatar>
          </div>
          <div layout layout-vertical>
            <b>{{ roleWithAdmins.name }}</b>
            <span>{{
              'app.visibility.team_members_with_count' | translate: { count: roleWithAdmins.count }
            }}</span>
          </div>
        </div>
        @if (roleWithAdmins.admins.length) {
          <div layout-horizontal>
            <rt-icon-button
              size="small"
              variant="plain"
              [iconName]="expanded ? 'keyboard-arrow-up' : 'keyboard-arrow-down'"
              (click)="toggleList($event)"
            >
            </rt-icon-button>
          </div>
        }
      </div>
    </div>
    @if (expanded) {
      @for (admin of roleWithAdmins.admins; track trackById($index, admin); let isLast = $last) {
        <rt-visibility-admin-item
          [admin]="admin"
          [kind]="'simple-admin'"
          [currentAdmin]="currentAdmin"
          [hasDivider]="!isLast"
        ></rt-visibility-admin-item>
      }
    }
  </div>
  @if (hasDivider) {
    <rt-divider></rt-divider>
  }
}

@if (kind === 'simple-admin') {
  <div class="simple-admin" layout-horizontal>
    <div class="avatar" margin-right-medium margin-left-small-xx>
      <rt-avatar
        [type]="admin.hasAvatar ? 'image' : 'initials'"
        [initials]="admin.initials"
        [size]="'small'"
        [shape]="'oval'"
        [imageSrc]="admin.photoThumbUrl"
        context="admin"
      >
      </rt-avatar>
    </div>
    <div class="name" margin-left-small-xx layout-flex-1-0 layout-align-items-center>
      <rt-truncate>{{ admin.firstName }} {{ admin.lastName }}</rt-truncate>
    </div>
  </div>
}

@if (kind === 'no-access') {
  <div class="admin no-access" padding-tb-medium padding-lr>
    <div layout-horizontal layout-align-items-center>
      <rt-checkbox [checked]="false" [disabled]="true" margin-right-small-x> </rt-checkbox>
      <rt-avatar
        [type]="admin.hasAvatar ? 'image' : 'initials'"
        [initials]="admin.initials"
        [size]="'base'"
        [shape]="'oval'"
        [imageSrc]="admin.photoThumbUrl"
        margin-right-medium
        context="admin"
      ></rt-avatar>
      <div layout-vertical>
        <rt-heading>
          <rt-truncate>
            {{ admin.firstName }} {{ admin.lastName }}
            @if (currentAdmin && admin.id === currentAdmin.id) {
              ({{ 'app.common.me' | translate }})
            }
          </rt-truncate>
        </rt-heading>
        <div class="subheading" layout-horizontal>
          <rt-truncate>
            {{ admin.roleName }}
          </rt-truncate>
          @if (roleAssignmentsGroup![admin.roleId]) {
            <rt-divider variant="dot disabled"></rt-divider>
            <span class="role-can-view">{{ 'app.visibility.can_view' | translate }}</span>
          }
        </div>
      </div>
    </div>
  </div>
  @if (hasDivider) {
    <rt-divider></rt-divider>
  }
}
